/**
 * Whether two presigned urls point at the same stored object. Signing only
 * changes the query string, so the part before it decides.
 */
export function isSameStoredObject(a: string, b: string): boolean {
  return withoutQuery(a) === withoutQuery(b);
}

const withoutQuery = (url: string): string => url.split("?")[0];
